import React from "react";
import CmsContent from "./CmsContent";
import { IContentRef } from "../interfaces/IContentRef";
import { useCmsData } from "../../hooks/useCmsData";

const CmsContentReference : React.FC<IContentRef> = ({ _ref}) => {
    const [data] = useCmsData<Array<any>>({docId: _ref});
    
    return <>{data?.map((d, i) => <CmsContent key={`content_${i}_${_ref}`} {...d} />)}</>
}

export default CmsContentReference;